import React from 'react';

const PlayIcon = ({className}) => (
  <svg className={className} viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.6043 7.14679C12.2422 7.53675 12.2422 8.46325 11.6043 8.85321L1.77158 14.8641C1.10523 15.2714 0.25 14.7919 0.25 14.0109L0.25 1.98913C0.25 1.20814 1.10523 0.728581 1.77157 1.13593L11.6043 7.14679Z" fill="white"/>
  </svg>

);

export default PlayIcon;
